import $ from 'jquery';
import {
    getMeilisearchConfig,
    buildAutocompleteIndexNames,
    createMeilisearchDirectSearchClient,
    createAutocompleteSearchClient,
    extractAutocompletePartIdentity,
    dedupeAutocompleteHits,
} from './meilisearch-helpers.js';

var _quickOrderSearchClient = null;

/** Same attributes as navbar part hits (minimize payload). */
var QUICK_ORDER_PART_ATTRS = [
    'objectID',
    'meili_id',
    'id',
    'Part',
    'PartNumber',
    'part',
    'part_number',
    'BrandLabel',
    'AAIABrandCode',
    'brand_slug',
    'brandSlug',
    'brand_url_string',
    'brand',
    'slug',
    'pace_slug',
    'pace',
    'image',
    'thumbnail',
    'pace_image',
    'name',
    'title',
    'display_name',
    'ItemNumber',
    'PartTerminologyName',
    'PartNumberURLString',
];

function getQuickOrderMeiliSearchClient() {
    if (_quickOrderSearchClient) {
        return _quickOrderSearchClient;
    }
    var cfg = getMeilisearchConfig();
    if (!cfg.host || !cfg.searchKey) {
        return null;
    }
    var direct = createMeilisearchDirectSearchClient(cfg);
    _quickOrderSearchClient = createAutocompleteSearchClient(direct, 280, 25);
    return _quickOrderSearchClient;
}

export function mapMeiliHitsToQuickOrderRows(hits) {
    return dedupeAutocompleteHits(hits || [], function (hit) {
        var id = extractAutocompletePartIdentity(hit);
        return (id.brandCode || '') + '|' + (id.partNumber || '');
    })
        .map(function (hit) {
            var id = extractAutocompletePartIdentity(hit);
            var partNumber =
                (id.partNumber || '').trim() ||
                (hit &&
                    (hit.Part ||
                        hit.PartNumber ||
                        hit.part ||
                        hit.part_number ||
                        '')) ||
                '';
            var aaia =
                (id.brandCode || '').trim() ||
                (hit && hit.AAIABrandCode ? String(hit.AAIABrandCode) : '') ||
                '';
            if (!partNumber || !aaia) {
                return null;
            }
            var label =
                (hit && hit.BrandLabel) ||
                (hit && hit.BrandName) ||
                (hit && hit.Brand) ||
                null;
            return {
                AAIABrandCode: aaia,
                BrandLabel: label,
                PartNumber: partNumber,
                PartNumberURLString: encodeURIComponent(partNumber),
            };
        })
        .filter(Boolean);
}

export function searchQuickOrderPartsMeili(query, options) {
    options = options || {};
    var q = (query || '').trim();
    if (q.length < 2) {
        return Promise.resolve([]);
    }
    var memberCode = ($('#member_code').val() || '').trim();
    if (!memberCode) {
        return Promise.resolve([]);
    }
    var client = getQuickOrderMeiliSearchClient();
    if (!client) {
        return Promise.resolve([]);
    }
    var indexNames = buildAutocompleteIndexNames(memberCode);
    var requests = [
        {
            indexName: indexNames.parts,
            params: {
                query: q,
                hitsPerPage: 20,
                attributesToRetrieve: QUICK_ORDER_PART_ATTRS,
            },
        },
    ];
    return client
        .search(requests, { signal: options.signal })
        .then(function (res) {
            var hits =
                res.results && res.results[0] && res.results[0].hits
                    ? res.results[0].hits
                    : [];
            return mapMeiliHitsToQuickOrderRows(hits);
        })
        .catch(function () {
            return [];
        });
}

export function searchQuickOrderPartsFallback(query, brandAaia) {
    var q = (query || '').trim();
    if (q.length < 2) {
        return Promise.resolve([]);
    }
    var url = 'catalog/ajaxPartAutocomplete/' + encodeURIComponent(q);
    if (brandAaia) {
        url += '/' + encodeURIComponent(brandAaia);
    }
    return $.getJSON(url).then(function (parts) {
        return Array.isArray(parts) ? parts : [];
    }).catch(function () {
        return [];
    });
}

/**
 * Meilisearch first; if empty or unconfigured, PHP/YMM quick endpoint.
 */
export function searchQuickOrderParts(query, options) {
    options = options || {};
    var q = (query || '').trim();
    if (q.length < 2) {
        return Promise.resolve([]);
    }
    var brandAaia = options.brandAaia || '';
    return searchQuickOrderPartsMeili(q, options).then(function (rows) {
        if (rows.length > 0) {
            return rows;
        }
        return searchQuickOrderPartsFallback(q, brandAaia);
    });
}
